import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { FC } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { IconLabelSelector } from "@/components/uis/IconLabelSelector";
import type { Types } from "@/components/uis/IconLabelSelector/utils";
import styles from "./styles.module.css";
type SideBarItemsProps = {
  list: {
    icon: string;
    customLabel?: string;
    to: string;
  }[];
  currentPath: string;
};
export const SideBarItems: FC<SideBarItemsProps> = t0 => {
  const $ = _c(7);
  const {
    list,
    currentPath
  } = t0;
  let t1;
  if ($[0] !== currentPath || $[1] !== list) {
    let t2;
    if ($[3] !== currentPath) {
      t2 = item => {
        const current = currentPath === item.to;
        return <Link key={item.icon} href={item.to}><Box className={`${styles.link} ${current ? styles.linkActive : ""}`}><IconLabelSelector type={item.icon as Types} customLabel={item.customLabel} iconColor={current ? "primary" : undefined} textColor={current ? "primary" : undefined} /></Box></Link>;
      };
      $[3] = currentPath;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = list.map(t2);
    $[0] = currentPath;
    $[1] = list;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <List className={styles.list}>{t1}</List>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};